import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M1.90006 22.46C2.40006 32.2 10.82 39.63 17.26 38.97C17.26 38.97 21.06 46.0699 27 47.0599L27.5 42.6C27.5 42.6 45.33 52.51 64.49 39.13C64.49 39.13 63.0001 43.09 61.6801 44.58C61.6801 44.58 73.24 47.39 79.35 33.35C85.46 19.31 83.48 5.77002 83.48 5.77002L4.54008 1.80994C4.55008 1.81994 1.41006 12.72 1.90006 22.46Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
